import { Ref } from 'react'

import { CheckIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'

import { useFormContext } from './form'
import { scrollToFirstInvalidField } from './form-utils'

export type SubmitButtonProps = {
  disableIsTouch?: boolean
  hideCheckMark?: boolean
  isLoading?: boolean
  lockAfterSubmit?: boolean
  ref?: Ref<HTMLButtonElement>
} & React.ComponentProps<typeof Button>

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  disableIsTouch = false,
  hideCheckMark = false,
  isLoading,
  lockAfterSubmit = true,
  onClick,
  ref,
  ...props
}) => {
  const form = useFormContext()

  return (
    <form.Subscribe
      selector={(state) => [
        state.isSubmitting,
        state.isTouched,
        state.isSubmitted,
        state.errorMap
      ]}
    >
      {([isSubmitting, isTouched, isSubmitted, errorMap]) => {
        const isLocked = lockAfterSubmit && isSubmitted && !isTouched
        return (
          <Button
            disabled={
              isLoading ||
              isLocked ||
              (!disableIsTouch && !isTouched && !isSubmitted)
            }
            onClick={(e) => {
              onClick?.(e)
              e.preventDefault()
              e.stopPropagation()
              void form.handleSubmit()
              scrollToFirstInvalidField(100)
            }}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref={ref as any}
            type="submit"
            {...props}
          >
            {!isSubmitting && !isLoading && !hideCheckMark && (
              <CheckIcon size={16} />
            )}
            {(isLoading || isSubmitting) && (
              <Spinner className="text-current" />
            )}
            {props.children}
          </Button>
        )
      }}
    </form.Subscribe>
  )
}
